import { Injectable } from '@angular/core';
import { HelperService } from '../utils/helper.service';
import { ApiService } from '../api.service';
import { map } from 'rxjs/operators';
import { DataObject } from 'app/interfaces/data-objects';
@Injectable({
  providedIn: 'root'
})
export class FeeSplitsService {

  constructor(
    private helperService: HelperService,
    private api: ApiService,
  ) { }

  getFeeSplits(transactionId: number) {
    return this.api.get(`/api/transactions/${transactionId}/fee_split/`).pipe(
      map(response => {
        return response.fee_splits.filter(fee_split => fee_split.adjusted === 'latest');
      })
    );
  }

  createFeeSplit(transactionId: number, feeSplit: DataObject) {
    return this.api.post(`/api/transactions/${transactionId}/fee_split/`, feeSplit);
  }

  saveFeeSplit(transactionId: number, feeSplit: DataObject) {
    return this.api.put(`/api/transactions/${transactionId}/fee_split/${feeSplit.id}/`, feeSplit).pipe(
      map(response => {
        return response;
      })
    );
  }

  deleteFeeSplit(transactionId: number, feeSplitId: number) {
    return this.api.delete(`/api/transactions/${transactionId}/fee_split/${feeSplitId}/`);
  }

  getRemainingAmount(feeSplits, feesTotal: number) {
    let remainingAmount = feesTotal;
    feeSplits.map(feeSplit => {
      remainingAmount -= +feeSplit.flat_amount;
    });
    return remainingAmount;
  }

  getTotalAmount(feeSplits) {
    let totalAmount = 0;
    feeSplits.map(feeSplit => {
      totalAmount += +feeSplit.flat_amount;
    });
    return totalAmount;
  }

  validateZeroAmounts(feeSplits) {
    if (feeSplits && feeSplits.length > 0) {
      let flatAmounts = 0;
      feeSplits.map(feeSplit => {
        if (+feeSplit.flat_amount === 0 || feeSplit.flat_amount === '0.00') {
          flatAmounts++;
        }
      });
      if (flatAmounts > 0) {
        return false;
      } else {
        return true;
      }
    }
  }

  getTotalDisbursementAmount(feeSplits) {
    let totalDisbursementAmount = 0;
    feeSplits.map(feeSplit => {
      totalDisbursementAmount += +feeSplit.disbursement_allocation_amount;
    });
    return totalDisbursementAmount;
  }

  validateNegativeActualFeeSplits(feeSplits) {
    if (feeSplits && feeSplits.length > 0) {
      let negativeActualFeeSplit = 0;
      feeSplits.map(feeSplit => {
        if (+feeSplit.actual_fee < 0) {
          negativeActualFeeSplit++;
        }
      });
      if (negativeActualFeeSplit > 0) {
        return false;
      } else {
        return true;
      }
    }
  }

  billExternalCheck(feeSplits: any) {
    return feeSplits.find(feesplit => feesplit.bill_external === true) ? true : false;
  }

  isExternalBroker(feeSplits: any) {
    return feeSplits.find(feesplit => (feesplit.cross_border === false && feesplit.bill_external === true)) ? true : false;
  }


  getFeeSplitIndex(feeSplits: DataObject[], feeSplitId: number): number {
    let currentFeeSplitIndex = 0;
    feeSplits.forEach((_feeSplit, index) => {
      if (feeSplitId === _feeSplit.id) {
        currentFeeSplitIndex = index;
      }
    });
    return currentFeeSplitIndex;
  }

  getRemainingFeeSplitPercentage(feeSplits) {
    let remainder = 100;
    if ((feeSplits.length + 1) > 1) {
      for (let i = 0; i < feeSplits.length; i++) {
        remainder -= +feeSplits[i].percent_output;
      }
      if (remainder <= 0 || remainder >= 100) {
        return 0;
      } else {
        remainder = this.helperService.roundNumber(+remainder, 2);
      }
    }
    return remainder;
  }

  getBrokerDetails(brokerDetails: any) {
    if (brokerDetails.length >= 1) {
      const newBrokerDetails = brokerDetails.filter((broker: any) => broker.cb_send_hr === 'Y');
      // INFO: In some cases, data is wrong, and the broker has multi records with CB_SEND_HR = Y
      // If so, we will take the first record.
      if (newBrokerDetails && newBrokerDetails.length) {
        return newBrokerDetails[0];
      }
    }
    return brokerDetails;
  }

  calculateFeeSplitAmount(totalCbreAmount: number, percent: number) {
    // return +totalCbreAmount > 0 ? (+totalCbreAmount * (+percent / 100)).toFixed(2) : '0.00';
    let amount = 0;
    if (+totalCbreAmount > 0) {
      amount = +totalCbreAmount * (+percent / 100);
    }
    return this.helperService.getCurrencyFormat(+amount);
  }

  calculateFeeSplitPercent(totalCbreAmount: number, amount: number) {
    return +totalCbreAmount > 0 ? ((+amount / +totalCbreAmount) * 100).toFixed(8) : '0';
  }

  getBrokerDetailsByFuMo(brokerDetails: any, functionalUnit: number, managingOffice: number, laSetId: string): any {
    let filteredBrokerByFumo = null;
    if (brokerDetails && Array.isArray(brokerDetails) && managingOffice && functionalUnit && laSetId) {
      brokerDetails.forEach(broker => {
        if (broker.functional_unit.id === functionalUnit && broker.managing_office.id === managingOffice && broker.la_setid === laSetId) {
          filteredBrokerByFumo = broker;
        }
      });
    }
    return filteredBrokerByFumo;
  }

  getBrokerRegionSetId(feeSplit: any): string[] {
    let reg_region = '', broker_la_setid = '', company_office = '', business_unit = '', business_unit_gl = '';
    if (feeSplit) {
      // tslint:disable-next-line: max-line-length
      const [broker_details, managing_office, functional_unit, la_setid] = [feeSplit.broker_details, feeSplit.managing_office, feeSplit.functional_unit, feeSplit.la_setid];
      if (broker_details && Array.isArray(broker_details)) {
        if (broker_details.length > 1) {
          broker_details.forEach(broker => {
          // tslint:disable-next-line: max-line-length
            if ((broker.managing_office.id === managing_office && broker.functional_unit.id === functional_unit && broker.la_setid === la_setid)) {
              reg_region = broker.reg_region;
              broker_la_setid = broker.la_setid;
              company_office = `${broker.la_setid} - ${broker.functional_unit.name} - ${broker.managing_office.name}`;
              business_unit = broker.business_unit;
              business_unit_gl = broker.business_unit_gl;
            }
          });
        } else {
          reg_region = broker_details[0].reg_region;
          broker_la_setid = broker_details[0].la_setid;
          company_office = `${broker_details[0].la_setid} - ${broker_details[0].functional_unit.name} - ${broker_details[0].managing_office.name}`;
          business_unit = broker_details[0].business_unit;
          business_unit_gl = broker_details[0].business_unit_gl;
        }
      }
    }
    return [reg_region, broker_la_setid, company_office, business_unit, business_unit_gl];
  }

  getCompanyOffice(feeSplit: any): string {
    if (feeSplit.company_office && feeSplit.company_office !== '') {
      return feeSplit.company_office;
    }
    const [, , companyOffice] = this.getBrokerRegionSetId(feeSplit);
    return companyOffice;
  }

  isUploadDealFileRequired(userCountry) {
    return !['KOR', 'THA', 'PHL', 'VNM'].includes(userCountry);
  }

}
